import React from 'react';
import { Drag } from 'components/ui/Icon/Streamline';

const ContentOption = ({ option }) => {
  return (
    <div className="JourneyBuilderContentOption">
      <Drag className="JourneyBuilderContentOption-handle fs-0" />
      {option.icon}
      <p className="JourneyBuilderContentOption-text">{option.text}</p>
    </div>
  );
};

export default ContentOption;
